import { useState } from "react";
import { useNavigate } from "react-router-dom";

function Intro() {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();

  const slides = [
    {
      title: "Easy Ordering",
      desc: "Choose from curated menus daily — fresh and ready to enjoy.",
      img: "https://images.unsplash.com/photo-1504674900247-0877df9cc836",
    },
    {
      title: "Fast Delivery",
      desc: "Get your food delivered quickly at your doorstep.",
      img: "https://images.unsplash.com/photo-1521305916504-4a1121188589",
    },
    {
      title: "Best Quality",
      desc: "We serve only the best quality food for you.",
      img: "https://images.unsplash.com/photo-1499028344343-cd173ffc68a9",
    },
  ];

  const next = () => {
    if (step < 2) {
      setStep(step + 1);
    } else {
      localStorage.setItem("introDone", true);
      navigate("/home");
    }
  };

  const skip = () => {
    localStorage.setItem("introDone", true);
    navigate("/home");
  };

  return (
    <div style={styles.container}>
      {/*  Skip Button */}
      <div style={styles.skipContainer}>
        <button style={styles.skipBtn} onClick={skip}>Skip</button>
      </div>

      {/*  Content Section */}
      <div style={styles.content}>
        <img src={slides[step].img} style={styles.image} alt={slides[step].title} />
        <h2 style={styles.title}>{slides[step].title}</h2>
        <p style={styles.desc}>{slides[step].desc}</p>
      </div>

      {/*  Bottom Navigation */}
      <div style={styles.footer}>
        <div style={styles.dotsContainer}>
          {slides.map((_, i) => (
            <div
              key={i}
              style={{
                ...styles.dot,
                backgroundColor: step === i ? "#ff1e1e" : "#e0e0e0",
                width: step === i ? "24px" : "8px",
              }}
            />
          ))}
        </div>

        <button style={styles.nextBtn} onClick={next}>
          {step === 2 ? "Get Started" : "Next"}
        </button>
      </div>
    </div>
  );
}

export default Intro;

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fff",
    padding: "20px",
    boxSizing: "border-box",
  },
  skipContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
  skipBtn: {
    background: "none",
    border: "none",
    color: "#666",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  image: {
    width: "100%",
    maxWidth: "400px",
    height: "40vh",
    objectFit: "cover",
    borderRadius: "30px",
    marginBottom: "30px",
  },
  title: {
    fontSize: "26px",
    fontWeight: "bold",
    margin: "0 0 15px 0",
    color: "#1a1a1a",
  },
  desc: {
    fontSize: "16px",
    color: "#777",
    lineHeight: "1.5",
    padding: "0 20px",
  },
  footer: {
    paddingBottom: "20px",
  },
  dotsContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "6px",
    marginBottom: "30px",
  },
  dot: {
    height: "8px",
    borderRadius: "4px",
    transition: "all 0.3s ease",
  },
  nextBtn: {
    width: "100%",
    padding: "18px",
    background: "#ff1e1e",
    color: "#fff",
    border: "none",
    borderRadius: "15px",
    fontSize: "18px",
    fontWeight: "bold",
    boxShadow: "0 10px 20px rgba(255, 30, 30, 0.2)",
    cursor: "pointer",
  },
};